// AuditIQ — Per-route SEO metadata (Iter 18, spec §11)
// Canonical base hardcoded to i-audit.com per spec.

export const CANONICAL_BASE_URL = "https://i-audit.com";
export const OG_IMAGE = `${CANONICAL_BASE_URL}/assets/auditiq-preview.png`;
export const OG_LOGO = `${CANONICAL_BASE_URL}/assets/auditiq-logo.png`;

export const ROUTE_META = {
  "/": {
    title: "AuditIQ Sports — Athlete Performance, Compliance, and Health Intelligence",
    description:
      "AuditIQ Sports delivers real-time athlete tracking, compliance oversight, and Health IQ risk monitoring for universities and athletic programs.",
  },
  "/dashboard": {
    title: "Dashboard — AuditIQ Sports Command Center",
    description:
      "AuditIQ Sports command center — real-time athlete performance, Health IQ risk monitoring, and compliance oversight for institutional athletic programs.",
  },
  "/teams": {
    title: "Teams — AuditIQ Sports",
    description:
      "Browse and manage athletic team rosters, schedules, and performance analytics across all sports programs on the AuditIQ platform.",
  },
  "/athletes": {
    title: "Athletes — AuditIQ Sports",
    description:
      "Track individual athlete performance, Health IQ readiness scores, recruiting status, and compliance standing in one unified profile.",
  },
  "/coaches": {
    title: "Coaches — AuditIQ Sports",
    description:
      "Coach management dashboard for staff assignments, team oversight, and performance reporting across university and high school programs.",
  },
  "/health-iq": {
    title: "Health IQ — Athlete Readiness & Risk Monitoring",
    description:
      "Monitor athlete readiness, fatigue risk, recovery scores, and availability status with AuditIQ Health IQ — built for trainers and athletic directors.",
  },
  "/compliance": {
    title: "Compliance — NCAA & FHSAA Oversight",
    description:
      "Manage NCAA and FHSAA compliance workflows, eligibility actions, audit trails, and institutional oversight with AuditIQ Compliance.",
  },
  "/reports": {
    title: "Reports — Institutional Reporting Suite",
    description:
      "Generate and export institutional performance reports, Health IQ risk summaries, and compliance documentation from the AuditIQ platform.",
  },
  "/about": {
    title: "About AuditIQ Sports",
    description:
      "Learn about AuditIQ Sports — the GovTech platform delivering athlete intelligence, compliance oversight, and Health IQ monitoring to universities nationwide.",
  },
  "/security": {
    title: "Security & Compliance — AuditIQ Sports",
    description:
      "AuditIQ Sports security posture: HIPAA-aware practices, FERPA audit trails (5/6-year retention), AES-256 credential encryption, JWT-bound role-based access control, and NCAA Bylaw 12.5 NIL support.",
  },
  "/contact": {
    title: "Contact AuditIQ Sports",
    description:
      "Contact the AuditIQ Sports team to schedule a demo, request a proposal, or learn about institutional licensing.",
  },
  "/privacy": {
    title: "Privacy Policy — AuditIQ Sports",
    description:
      "AuditIQ Sports privacy policy — how we handle athlete data, HIPAA-aware practices, and institutional data protection.",
  },
  "/terms": {
    title: "Terms of Service — AuditIQ Sports",
    description:
      "AuditIQ Sports terms of service for institutional users, athletic programs, and university administrators.",
  },
};

export const DEFAULT_META = ROUTE_META["/"];

export const getMetaForPath = (pathname) => {
  if (ROUTE_META[pathname]) return ROUTE_META[pathname];
  // Match prefix, e.g. /athlete/abc → /athletes
  if (pathname.startsWith("/athlete/")) return ROUTE_META["/athletes"];
  if (pathname.startsWith("/auditiq-sports")) return ROUTE_META["/dashboard"];
  if (pathname.startsWith("/demo/sports")) return ROUTE_META["/dashboard"];
  return DEFAULT_META;
};

// JSON-LD blocks (spec §14)
export const JSONLD_BLOCKS = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "AuditIQ Sports",
    url: CANONICAL_BASE_URL,
    logo: OG_LOGO,
    sameAs: [
      "https://twitter.com/AuditIQ",
      "https://www.linkedin.com/company/auditiq",
      "https://github.com/auditiq",
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "AuditIQ Sports",
    alternateName: "Health IQ Platform",
    applicationCategory: "Sports Analytics",
    operatingSystem: "Web",
    url: CANONICAL_BASE_URL,
    description:
      "AuditIQ Sports delivers real-time athlete tracking, compliance oversight, and Health IQ risk monitoring for universities and athletic programs.",
    offers: {
      "@type": "Offer",
      price: "Contact for Institutional Pricing",
    },
    compliance: "NCAA-ready",
    security: "HIPAA-aware",
  },
  {
    "@context": "https://schema.org",
    "@type": "SportsOrganization",
    name: "AuditIQ Sports Intelligence",
    url: CANONICAL_BASE_URL,
    sport: "Multi-Sport",
    description:
      "Institutional athletic oversight platform for universities and high school programs.",
  },
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "AuditIQ Health IQ",
    url: `${CANONICAL_BASE_URL}/health-iq`,
    description:
      "Health IQ is an athlete readiness and risk monitoring system providing fatigue scoring, recovery tracking, and availability risk assessment for athletic programs.",
    medicalSpecialty: "Sports Medicine Analytics",
  },
];
